import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import { Typography } from "@material-ui/core"
import { GatsbyImage } from "gatsby-plugin-image"

const MDXImageStyle = theme => ({
  root: props => ({
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    maxWidth: "100%",
    [theme.breakpoints.up("sm")]: {
      float: props.width !== "100%" ? props.align : "none",
      width: props.width,
      paddingTop: 0,
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      paddingRight: 0,
    },
  }),
  img: {
    width: "100%",
    height: "auto",
  },
  fig: {
    textAlign: "right",
  },
})
const useStyles = makeStyles(MDXImageStyle)

const getImageType = image => {
  if (typeof image === "string") {
    return "url"
  } else if ((image?.childImageSharp?.gatsbyImageData ?? false) !== false) {
    return "fluid"
  } else if ((image?.childImageSharp?.gatsbyImageData ?? false) !== false) {
    return "fixed"
  } else if ((image?.publicURL ?? false) !== false) {
    return "publicURL"
  } else {
    return "error"
  }
}

const renderImage = (type, image, alt, classes) => {
  switch (type) {
    case "url":
      return <img alt={alt} src={image} className={classes.img} />
    case "publicURL":
      return <img alt={alt} src={image.publicURL} className={classes.img} />
    case "fluid":
      return (
        <GatsbyImage
          image={image.childImageSharp.gatsbyImageData}
          alt={alt}
          className={classes.img}
        />
      )
    case "fixed":
      return (
        <GatsbyImage
          image={image.childImageSharp.gatsbyImageData}
          alt={alt}
          className={classes.img}
        />
      )
    case "error":
      return <div>Bild nicht gefunden!</div>
    default:
      break
  }
}

export default function MDXImage({
  caption,
  alt = "",
  image,
  align = "right",
  width = "45%",
}) {
  const classes = useStyles({ align, width })
  const imageType = getImageType(image)
  const altText = alt === "" ? caption : alt

  return (
    <figure className={classes.root}>
      {renderImage(imageType, image, altText, classes)}
      {caption && (
        <figcaption className={classes.fig}>
          <Typography variant="caption">[{caption}]</Typography>
        </figcaption>
      )}
    </figure>
  )
}
